import React from 'react';
import './mainbt.css'
import { useNavigate } from 'react-router-dom';

const Mainbt = (props) => {

    const navigate = useNavigate();

    return (
        <>
        <button 
            className='mainbt'
            onClick={() => navigate(props.link)}
        >
            <h6 className='letstart'>{props.mainbt}</h6>
            <div className='arrow'></div>
        </button>
        </>
    );
}
 
export default Mainbt;